import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CustomerPortal from "@/pages/customer/CustomerPortal";
import AdminShell from "@/pages/admin/AdminShell";
import BolView from "@/pages/BolView";
import InvoiceView from "@/pages/InvoiceView";
import RateConfirmationView from "@/pages/RateConfirmationView";
import SsoHandoff from "@/pages/SsoHandoff";

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-zinc-500 mono-label">
        Loading&hellip;
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "customer" ? "/portal" : "/admin"} replace />;
  }
  return children;
};

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "customer" ? "/portal" : "/admin"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/sso" element={<SsoHandoff />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/app" element={<RootRedirect />} />

          <Route
            path="/portal/*"
            element={
              <ProtectedRoute roles={["customer"]}>
                <CustomerPortal />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/*"
            element={
              <ProtectedRoute roles={["admin", "dispatcher"]}>
                <AdminShell />
              </ProtectedRoute>
            }
          />

          <Route
            path="/documents/bol/:id"
            element={
              <ProtectedRoute>
                <BolView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/invoice/:id"
            element={
              <ProtectedRoute>
                <InvoiceView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/rate-conf/:id"
            element={
              <ProtectedRoute roles={["admin", "dispatcher"]}>
                <RateConfirmationView />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
